import { useWebsiteBuilder } from '../context/WebsiteBuilderContext';
import DownloadOutput from '../components/DownloadOutput';
import { usePageTracking } from '../../../hooks/usePageTracking';

export default function ExportStepPage() {
  const { pages, theme, brandName, brandLogo, globalContactInfo, setIsExported, setProjectState } = useWebsiteBuilder();
  usePageTracking({ moduleName: 'Website Builder', submoduleName: 'Download', routePath: '/website-builder/export' });

  return (
    <DownloadOutput
      pages={pages}
      theme={theme}
      brandName={brandName}
      brandLogo={brandLogo}
      globalContactInfo={globalContactInfo}
      onDownloaded={() => {
        setIsExported(true);
        setProjectState('Downloaded');
      }}
    />
  );
}
